<template>
  <div>
    <el-form-item
      style="margin-bottom: 3px"
      v-for="(item, index) of list"
      :key="index"
    >
      <el-input
        placeholder="语言"
        v-model="item.language"
        style="width: 70px"
      ></el-input
      >：
      <el-input
        placeholder="文本"
        v-model="item.value"
        style="width: 300px"
      ></el-input>
      <el-button
        @click="remove(index)"
        style="margin-left: 10px"
        icon="el-icon-delete"
        circle
      ></el-button>
    </el-form-item>
    <el-button @click="add()" class="el-icon-plus">添加</el-button>
  </div>
</template>

<script>
const util = require("@/util");

export default {
  data() {
    return {
      list: [],
    };
  },

  props: {
    value: null,
    param: {},
  },

  watch: {
    list: {
      handler() {
        this.$emit("updated", this.format, this.param);
      },
      deep: true,
    },
  },

  computed: {
    format() {
      let entry = {};
      for (let item of this.list) {
        entry[item.language] = item.value;
      }

      return entry;
    },
  },

  async created() {
    if (this.value) {
      for (let v in this.value) {
        this.list.push({ language: v, value: this.value[v] });
      }
    }
  },
  components: {},

  methods: {
    /**
     * 增加一个
     */
    add() {
      this.list.push({
        language: "",
        value: "",
      });
    },

    /**
     * 删除一个
     */
    remove(index) {
      this.list.splice(index, 1);
    },
    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

